<template>
  <div class="catalog-info fl">
    <el-row :gutter="24" v-for="(item, index) in catalogList" :key="index">
      <el-col :span="24" class="catalog-list ccui-clearfix">
        <svg-icon :icon-class="item.icon" class="icon-catalog fl"></svg-icon>
        <div class="fl">
          <div class="column-btn-ellipsis" :title="item.number">
            {{ item.number }}
          </div>
          <span>{{ item.label }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { qryFinishedAmountAndProjectNum } from "@/app/shop/api/shopping";
export default {
  name: "catalog",
  data() {
    return {
      catalogList: [
        {
          label: "累计采购总金额（万元）",
          icon: "pur-total-money",
          number: ""
        },
        {
          label: "累计招标项目数（个）",
          icon: "zhaobiao-project-num",
          number: ""
        },
        {
          label: "累计询价项目数（个）",
          icon: "xunjia-project-num",
          number: ""
        },
        {
          label: "累计竞谈项目数（个）",
          icon: "jingtan-project-num",
          number: ""
        }
      ]
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      qryFinishedAmountAndProjectNum({}).then(res => {
        if (res.data.code === "0") {
          (this.catalogList[0].number = window.$computeUtil.getDividedToFormat(
            res.data.data.cumulativeAmount,
            10000
          )),
            (this.catalogList[1].number = res.data.data.biddingProjectNum);
          this.catalogList[2].number = res.data.data.inquiryProjectNum;
          this.catalogList[3].number = res.data.data.competeProjectNum;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.catalog-info {
  width: 230px;
  height: 370px;
  background: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /*justify-content: space-around;*/
  .el-row {
    margin-bottom: 30px;
  }
}
.fl {
  float: left;
}
.catalog-list {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #999999;
  letter-spacing: 0;
  font-weight: 400;
}
.catalog-list span {
  line-height: 18px;
  display: inline-block;
}
.catalog-list .column-btn-ellipsis {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #0089ef;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 500;
  margin-bottom: 5px;
  width: 160px;
}
.icon-catalog {
  width: 20px;
  height: 20px;
  margin-top: 6px;
  margin-right: 6px;
}
</style>
